import { dbPromise } from "./db";

export async function addToQueue(data) {
    const db = await dbPromise

    await db.add("queue", {
        ...data,
        createdAt: new Date().toISOString()
    })
}

export async function getAllQueue() {
    const db = await dbPromise
    return db.getAll("queue")
}

export async function removeFromQueue(id) {
    const db = await dbPromise
    return db.delete("queue", id)
}